import { Box, Typography, Button, Grid } from '@mui/material';
import COLORS from '../../../../../../constants/colors';
import ImpactImage from '../../../../../../assets/svg/impact.svg';
import { PrimaryButton } from '../../../../../Reusable/Button';

const Hero = () => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '60vh',
        display: 'flex',
        justifyContent: 'center',
        py: { xs: 6, md: 10 },
        px: { xs: 3, md: 6 },
      }}
    >
      <Grid
        container
        spacing={{ xs: 4, md: 8 }}
        justifyContent="center"
        alignItems="center"
        sx={{ maxWidth: 1400, width: '100%' }}
      >
        {/* Left Column (Impact Message) */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              maxWidth: 600,
              backgroundColor: 'rgba(255,255,255,0.9)',
              p: { xs: 3, md: 5 },
              borderRadius: 3,
            }}
          >
            <Typography
              variant="h3"
              fontWeight={700}
              color={COLORS.primary}
              mb={3}
              sx={{
                fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' },
                lineHeight: 1.1,
              }}
            >
              Making a Difference Together
            </Typography>
            <Typography
              variant="body1"
              color={COLORS.text}
              mb={4}
              sx={{
                fontSize: { xs: '0.9rem', md: '1rem' },
                lineHeight: 1.7,
                letterSpacing: '0.015em',
                whiteSpace: 'pre-line',
              }}
            >
              Every campaign started on our platform has touched lives and created real impact. 
              From funding life-saving medical treatments to supporting education and small businesses, 
              our community has come together to make a difference. Join us in empowering dreams and 
              transforming lives—one campaign at a time.
            </Typography>
           
            <PrimaryButton>
              See Our Impact
            </PrimaryButton>
          </Box>
        </Grid>

        {/* Right Column (Impact Image) */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={ImpactImage}
            alt="Visual representation of impact and community support"
            sx={{
              width: '100%',
              maxHeight: 440,
              objectFit: 'cover',
              borderRadius: 4,
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.03)',
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Hero;
